import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "d-flex align-center justify-space-between w-100" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "text-subtitle-2 mb-1 d-flex" }
const _hoisted_10 = {
  class: "text-right",
  style: {"min-width":"180px"}
}
const _hoisted_11 = { class: "ml-2" }
const _hoisted_12 = { class: "text-subtitle-2 mb-1 d-flex" }
const _hoisted_13 = {
  class: "text-right",
  style: {"min-width":"180px"}
}
const _hoisted_14 = { class: "ml-2" }
const _hoisted_15 = { class: "text-subtitle-2 mb-1 d-flex" }
const _hoisted_16 = {
  class: "text-right",
  style: {"min-width":"180px"}
}
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = { class: "text-right text-caption font-weight-bold pa-1" }
const _hoisted_19 = { class: "text-right text-caption font-weight-bold pa-1" }
const _hoisted_20 = { class: "text-right text-caption font-weight-bold pa-1" }
const _hoisted_21 = { class: "text-right text-caption font-weight-bold pa-1" }
const _hoisted_22 = { class: "text-right text-caption pa-1" }
const _hoisted_23 = { class: "text-right text-caption pa-1" }
const _hoisted_24 = { class: "text-right text-caption pa-1" }
const _hoisted_25 = { class: "text-right text-caption pa-1" }
const _hoisted_26 = { class: "text-left text-caption font-weight-bold pa-1" }
const _hoisted_27 = { class: "text-right text-caption font-weight-bold pa-1" }
const _hoisted_28 = { class: "text-right text-caption font-weight-bold pa-1" }
const _hoisted_29 = { class: "text-right text-caption font-weight-bold pa-1" }
const _hoisted_30 = { class: "text-left text-caption pa-1" }
const _hoisted_31 = { class: "text-right text-caption pa-1" }
const _hoisted_32 = { class: "text-left text-subtitle-2 font-weight-bold pa-1" }
const _hoisted_33 = { class: "text-right text-subtitle-2 font-weight-bold pa-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_NowhowDatepicker = _resolveComponent("NowhowDatepicker")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_simple_table = _resolveComponent("v-simple-table")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Form = _resolveComponent("Form")!
  const _component_CustomerPickerDialog = _resolveComponent("CustomerPickerDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.missingDataAlert)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "warning",
            variant: "tonal",
            class: "mb-4",
            closable: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.stammdatenInkomplett')), 1),
                _createVNode(_component_v_btn, {
                  color: "warning",
                  variant: "elevated",
                  size: "small",
                  onClick: _ctx.goToLieferanteinstellungen
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('lieferanten.rechnungformular.lieferanteneinstellungen')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.pdfUpload')) + " *", 1),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_file_input, {
                          modelValue: _ctx.pdfFile,
                          "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pdfFile) = $event)),
                            _ctx.onPdfFileChanged
                          ],
                          accept: ".pdf,application/pdf",
                          label: _ctx.$t('lieferanten.rechnungformular.pdfAuswaehlen'),
                          variant: "outlined",
                          density: "comfortable",
                          "prepend-icon": "mdi-file-pdf-box",
                          "show-size": "",
                          clearable: "",
                          class: "flex-grow-1",
                          "error-messages": _ctx.pdfFile ? [] : [_ctx.$t('lieferanten.rechnungformular.pdfErforderlich')]
                        }, null, 8, ["modelValue", "label", "error-messages", "onUpdate:modelValue"]),
                        (_ctx.pdfPreviewUrl)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              icon: "mdi-eye",
                              variant: "text",
                              size: "small",
                              color: "primary",
                              class: "ml-2 mb-5",
                              title: _ctx.$t('lieferanten.rechnungformular.pdfVorschau'),
                              onClick: _ctx.openPdfPreview
                            }, null, 8, ["title", "onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Form, { ref: "formRef" }, {
        default: _withCtx(({ meta, validate }) => [
          _createVNode(_component_v_expansion_panels, {
            modelValue: _ctx.activePanel,
            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.activePanel) = $event)),
            variant: "accordion"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel, {
                value: "header",
                "data-section": "header",
                eager: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('lieferanten.rechnungsformular.headerTitle')), 1),
                        (_ctx.headerSectionValid)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              color: "success",
                              class: "ml-2"
                            }, {
                              default: _withCtx(() => _cache[47] || (_cache[47] = [
                                _createTextVNode("mdi-check-circle")
                              ])),
                              _: 1
                            }))
                          : (_ctx.headerSectionTouched)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                color: "error",
                                class: "ml-2"
                              }, {
                                default: _withCtx(() => _cache[48] || (_cache[48] = [
                                  _createTextVNode("mdi-alert-circle")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.documentType,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.documentType) = $event)),
                                name: "documentType",
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.documentType')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_select, {
                                    modelValue: _ctx.formData.documentType,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.documentType) = $event)),
                                    items: _ctx.dokumentTypes,
                                    label: _ctx.$t('lieferanten.rechnungformular.dokumenttyp') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "items", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.documentIdentifier,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.documentIdentifier) = $event)),
                                name: "documentIdentifier",
                                label: _ctx.$t('lieferanten.rechnungformular.rechnungsnummer'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.documentIdentifier')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.documentIdentifier,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.documentIdentifier) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.rechnungsnummer') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    type: "text",
                                    inputmode: "numeric",
                                    maxlength: "12",
                                    "error-messages": errors,
                                    onBlur: handleBlur,
                                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.documentIdentifier = ($event.target as HTMLInputElement).value.replace(/\D/g, '')))
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.documentIssueDate,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.documentIssueDate) = $event)),
                                name: "documentIssueDate",
                                label: _ctx.$t('lieferanten.rechnungformular.rechnungsdatum'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.documentIssueDate')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_NowhowDatepicker, {
                                    modelValue: _ctx.formData.documentIssueDate,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.documentIssueDate) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.rechnungsdatum') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    error: errors.length > 0,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "error", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.customerNumber,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.customerNumber) = $event)),
                                name: "customerNumber",
                                label: _ctx.$t('lieferanten.rechnungformular.kundennummerBeimLieferanten'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.customerNumber')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.customerNumber,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.customerNumber) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.kundennummerBeimLieferanten') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.deliveryDate,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.deliveryDate) = $event)),
                                name: "deliveryDate",
                                label: _ctx.$t('lieferanten.rechnungformular.lieferdatum'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.deliveryDate')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_NowhowDatepicker, {
                                    modelValue: _ctx.formData.deliveryDate,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.deliveryDate) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.lieferdatum') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.orderDate,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.orderDate) = $event)),
                                name: "orderDate"
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_NowhowDatepicker, {
                                    modelValue: _ctx.formData.orderDate,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.orderDate) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.bestelldatum'),
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.orderReference,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.orderReference) = $event)),
                                name: "orderReference"
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.orderReference,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.orderReference) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.bestellreferenz'),
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur,
                                    onKeydown: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.handleTabFromLastField($event, 'header')), ["tab"]))
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                tabindex: "-1",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToNext('customer')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('common.next')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel, {
                value: "customer",
                "data-section": "customer",
                eager: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.kunde')), 1),
                        (_ctx.customerSectionValid)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              color: "success",
                              class: "ml-2"
                            }, {
                              default: _withCtx(() => _cache[49] || (_cache[49] = [
                                _createTextVNode("mdi-check-circle")
                              ])),
                              _: 1
                            }))
                          : (_ctx.customerSectionTouched)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                color: "error",
                                class: "ml-2"
                              }, {
                                default: _withCtx(() => _cache[50] || (_cache[50] = [
                                  _createTextVNode("mdi-alert-circle")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.tvsCustomerNumber,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.tvsCustomerNumber) = $event)),
                                name: "tvsCustomerNumber",
                                label: _ctx.$t('lieferanten.rechnungformular.tvskundennummer'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.tvsCustomerNumber')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.tvsCustomerNumber,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.tvsCustomerNumber) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.tvskundennummer') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    maxlength: "4",
                                    type: "text",
                                    inputmode: "numeric",
                                    "error-messages": errors,
                                    "append-inner-icon": "mdi-magnify",
                                    onBlur: handleBlur,
                                    "onClick:appendInner": _cache[19] || (_cache[19] = ($event: any) => (_ctx.showCustomerPicker = true)),
                                    onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.formData.tvsCustomerNumber = ($event.target as HTMLInputElement).value.replace(/\D/g, ''))),
                                    onKeydown: _cache[21] || (_cache[21] = _withKeys(($event: any) => (_ctx.handleTabToPositions($event)), ["tab"]))
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.companyName,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.companyName) = $event)),
                                name: "companyName",
                                label: _ctx.$t('lieferanten.rechnungformular.firmenname'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.companyName')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.companyName,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.companyName) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.firmenname') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.address1,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.address1) = $event)),
                                name: "address1",
                                label: _ctx.$t('lieferanten.rechnungformular.adresse1'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.address1')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.address1,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.address1) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.adresse1') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.address2,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.address2) = $event)),
                                name: "address2",
                                label: _ctx.$t('lieferanten.rechnungformular.adresse2'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.address2')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.address2,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.address2) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.adresse2'),
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.address3,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.address3) = $event)),
                                name: "address3",
                                label: _ctx.$t('lieferanten.rechnungformular.adresse3'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.address3')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.address3,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.address3) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.adresse3'),
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.zipCode,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.zipCode) = $event)),
                                name: "zipCode",
                                label: _ctx.$t('lieferanten.rechnungformular.plz'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.zipCode')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.zipCode,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.zipCode) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.plz') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    type: "text",
                                    inputmode: "numeric",
                                    "error-messages": errors,
                                    onBlur: handleBlur,
                                    onInput: _cache[32] || (_cache[32] = ($event: any) => (_ctx.formData.zipCode = ($event.target as HTMLInputElement).value.replace(/\D/g, '')))
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.cityName,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.cityName) = $event)),
                                name: "cityName",
                                label: _ctx.$t('lieferanten.rechnungformular.ort'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.cityName')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.cityName,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.cityName) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.ort') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    "error-messages": errors,
                                    onBlur: handleBlur
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Field, {
                                modelValue: _ctx.formData.country,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.country) = $event)),
                                name: "country",
                                label: _ctx.$t('lieferanten.rechnungformular.land'),
                                rules: _ctx.getValidation('lieferantRechnungFormularApiDto.country')
                              }, {
                                default: _withCtx(({ errors, handleBlur }) => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.formData.country,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.country) = $event)),
                                    label: _ctx.$t('lieferanten.rechnungformular.land') + ' *',
                                    variant: "outlined",
                                    density: "comfortable",
                                    maxlength: "2",
                                    "error-messages": errors,
                                    onBlur: handleBlur,
                                    onKeydown: _cache[37] || (_cache[37] = _withKeys(($event: any) => (_ctx.handleTabFromLastField($event, 'customer')), ["tab"]))
                                  }, null, 8, ["modelValue", "label", "error-messages", "onBlur"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                tabindex: "-1",
                                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.goToNext('positions')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('common.next')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel, {
                value: "positions",
                "data-section": "positions",
                eager: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.positionen')), 1),
                        _createVNode(_component_v_chip, {
                          class: "ml-2",
                          size: "small",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.positions.length), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        class: "mb-4",
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.addPosition(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { left: "" }, {
                            default: _withCtx(() => _cache[51] || (_cache[51] = [
                              _createTextVNode("mdi-plus")
                            ])),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('lieferanten.rechnungformular.positionHinzufuegen')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panels, {
                        modelValue: _ctx.expandedPositions,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.expandedPositions) = $event)),
                        multiple: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (position, index) => {
                            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                              key: _ctx.getPositionId(position),
                              value: _ctx.getPositionId(position),
                              eager: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel_title, null, {
                                  actions: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                                        _createTextVNode("mdi-chevron-down")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_7, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.position')) + " " + _toDisplayString(index + 1), 1),
                                      _createVNode(_component_v_btn, {
                                        color: "error",
                                        size: "small",
                                        icon: "",
                                        onClick: _withModifiers(($event: any) => (_ctx.removePosition(index)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => _cache[52] || (_cache[52] = [
                                              _createTextVNode("mdi-delete")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_expansion_panel_text, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.SupplierArticleNumber,
                                              "onUpdate:modelValue": ($event: any) => ((position.SupplierArticleNumber) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].SupplierArticleNumber`,
                                              label: _ctx.$t('lieferanten.rechnungformular.lieferantenProduktnummer'),
                                              rules: _ctx.getValidation('lieferantRechnungFormularPositionApiDto.supplierArticleNumber')
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: position.SupplierArticleNumber,
                                                  "onUpdate:modelValue": ($event: any) => ((position.SupplierArticleNumber) = $event),
                                                  label: _ctx.$t('lieferanten.rechnungformular.lieferantenProduktnummer') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "error-messages": errors,
                                                  onBlur: 
                                                        () => {
                                                            handleBlur();
                                                            _ctx.onSupplierArticleNumberChange(index);
                                                        }
                                                    
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages", "onBlur"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name", "label", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.VetpointArticleNumber,
                                              "onUpdate:modelValue": ($event: any) => ((position.VetpointArticleNumber) = $event),
                                              label: _ctx.$t('lieferanten.rechnungformular.vetpointProduktnummer'),
                                              name: `positions[${_ctx.getPositionId(position)}].VetpointArticleNumber`
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: position.VetpointArticleNumber,
                                                  "onUpdate:modelValue": ($event: any) => ((position.VetpointArticleNumber) = $event),
                                                  label: _ctx.$t('lieferanten.rechnungformular.vetpointProduktnummer'),
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  hint: _ctx.$t('lieferanten.rechnungformular.autoFillHint'),
                                                  "persistent-hint": "",
                                                  "error-messages": errors,
                                                  onBlur: handleBlur
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "hint", "error-messages", "onBlur"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "label", "name"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.gtin,
                                              "onUpdate:modelValue": ($event: any) => ((position.gtin) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].gtin`
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: position.gtin,
                                                  "onUpdate:modelValue": ($event: any) => ((position.gtin) = $event),
                                                  label: "GTIN",
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "error-messages": errors,
                                                  onBlur: handleBlur
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages", "onBlur"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.productName,
                                              "onUpdate:modelValue": ($event: any) => ((position.productName) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].productName`,
                                              label: _ctx.$t('lieferanten.rechnungformular.produktname'),
                                              rules: _ctx.getValidation('lieferantRechnungFormularPositionApiDto.description')
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: position.productName,
                                                  "onUpdate:modelValue": ($event: any) => ((position.productName) = $event),
                                                  label: _ctx.$t('lieferanten.rechnungformular.produktname') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "error-messages": errors,
                                                  onBlur: handleBlur
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages", "onBlur"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name", "label", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.quantity,
                                              "onUpdate:modelValue": ($event: any) => ((position.quantity) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].quantity`,
                                              label: _ctx.$t('lieferanten.rechnungformular.menge'),
                                              rules: _ctx.getValidation('lieferantRechnungFormularPositionApiDto.quantity')
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: position.quantity,
                                                  "onUpdate:modelValue": ($event: any) => ((position.quantity) = $event),
                                                  modelModifiers: { number: true },
                                                  label: _ctx.$t('lieferanten.rechnungformular.menge') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  type: "number",
                                                  "error-messages": errors,
                                                  onBlur: handleBlur,
                                                  onInput: ($event: any) => (_ctx.calculatePositionTotals(index))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages", "onBlur", "onInput"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name", "label", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.unitOfMeasurement,
                                              "onUpdate:modelValue": ($event: any) => ((position.unitOfMeasurement) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].unitOfMeasurement`,
                                              label: _ctx.$t('lieferanten.rechnungformular.mengeneinheit'),
                                              rules: _ctx.getValidation('lieferantRechnungFormularPositionApiDto.unitOfMeasurement')
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_select, {
                                                  modelValue: position.unitOfMeasurement,
                                                  "onUpdate:modelValue": ($event: any) => ((position.unitOfMeasurement) = $event),
                                                  items: _ctx.unitOfMeasurementItems,
                                                  label: _ctx.$t('lieferanten.rechnungformular.mengeneinheit') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "error-messages": errors,
                                                  onBlur: handleBlur
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label", "error-messages", "onBlur"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name", "label", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.unitPrice,
                                              "onUpdate:modelValue": ($event: any) => ((position.unitPrice) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].unitPrice`,
                                              label: _ctx.$t('lieferanten.rechnungformular.einzelpreis'),
                                              rules: _ctx.getValidation('lieferantRechnungFormularPositionApiDto.unitPrice')
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  "model-value": _ctx.getCurrencyDisplayValue(`pos_${_ctx.getPositionId(position)}_unitPrice`, position.unitPrice),
                                                  label: _ctx.$t('lieferanten.rechnungformular.einzelpreis') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "error-messages": errors,
                                                  onFocus: ($event: any) => (_ctx.onCurrencyFocus(`pos_${_ctx.getPositionId(position)}_unitPrice`)),
                                                  onBlur: ($event: any) => (_ctx.onCurrencyBlur(handleBlur)),
                                                  "onUpdate:modelValue": ($event: any) => {
                                                        _ctx.handleCurrencyInput(`pos_${_ctx.getPositionId(position)}_unitPrice`, $event, position, 'unitPrice');
                                                        _ctx.calculatePositionTotals(index);
                                                    }
                                                }, null, 8, ["model-value", "label", "error-messages", "onFocus", "onBlur", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name", "label", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.vatRate,
                                              "onUpdate:modelValue": ($event: any) => ((position.vatRate) = $event),
                                              label: _ctx.$t('lieferanten.rechnungformular.mwstSatz'),
                                              name: `positions[${_ctx.getPositionId(position)}].vatRate`
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_select, {
                                                  modelValue: position.vatRate,
                                                  "onUpdate:modelValue": [($event: any) => ((position.vatRate) = $event), ($event: any) => (_ctx.calculatePositionTotals(index))],
                                                  items: _ctx.mwstSatzItems,
                                                  label: _ctx.$t('lieferanten.rechnungformular.mwstSatz') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  "error-messages": errors,
                                                  onBlur: handleBlur
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label", "error-messages", "onBlur"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "label", "name"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.taxableAmount,
                                              "onUpdate:modelValue": ($event: any) => ((position.taxableAmount) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].taxableAmount`,
                                              label: _ctx.$t('lieferanten.rechnungformular.totalExklMwst'),
                                              rules: _ctx.getValidation('lieferantRechnungFormularPositionApiDto.totalExclVat')
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  "model-value": 
                                                        _ctx.getCurrencyDisplayValue(`pos_${_ctx.getPositionId(position)}_taxableAmount`, position.taxableAmount)
                                                    ,
                                                  label: _ctx.$t('lieferanten.rechnungformular.totalExklMwst') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  hint: _ctx.$t('lieferanten.rechnungformular.berechnetHint'),
                                                  "persistent-hint": "",
                                                  "error-messages": errors,
                                                  onFocus: ($event: any) => (_ctx.onCurrencyFocus(`pos_${_ctx.getPositionId(position)}_taxableAmount`)),
                                                  onBlur: ($event: any) => (_ctx.onCurrencyBlur(handleBlur)),
                                                  "onUpdate:modelValue": ($event: any) => (
                                                        _ctx.handleCurrencyInput(`pos_${_ctx.getPositionId(position)}_taxableAmount`, $event, position, 'taxableAmount')
                                                    )
                                                }, null, 8, ["model-value", "label", "hint", "error-messages", "onFocus", "onBlur", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name", "label", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Field, {
                                              modelValue: position.taxAmountPayable,
                                              "onUpdate:modelValue": ($event: any) => ((position.taxAmountPayable) = $event),
                                              name: `positions[${_ctx.getPositionId(position)}].taxAmountPayable`,
                                              label: _ctx.$t('lieferanten.rechnungformular.totalMwst'),
                                              rules: _ctx.getValidation('lieferantRechnungFormularPositionApiDto.totalVat')
                                            }, {
                                              default: _withCtx(({ errors, handleBlur }) => [
                                                _createVNode(_component_v_text_field, {
                                                  "model-value": 
                                                        _ctx.getCurrencyDisplayValue(`pos_${_ctx.getPositionId(position)}_taxAmountPayable`, position.taxAmountPayable)
                                                    ,
                                                  label: _ctx.$t('lieferanten.rechnungformular.totalMwst') + ' *',
                                                  variant: "outlined",
                                                  density: "comfortable",
                                                  hint: _ctx.$t('lieferanten.rechnungformular.berechnetHint'),
                                                  "persistent-hint": "",
                                                  "error-messages": errors,
                                                  onFocus: ($event: any) => (_ctx.onCurrencyFocus(`pos_${_ctx.getPositionId(position)}_taxAmountPayable`)),
                                                  onBlur: ($event: any) => (_ctx.onCurrencyBlur(handleBlur)),
                                                  "onUpdate:modelValue": ($event: any) => (
                                                        _ctx.handleCurrencyInput(
                                                            `pos_${_ctx.getPositionId(position)}_taxAmountPayable`,
                                                            $event,
                                                            position,
                                                            'taxAmountPayable'
                                                        )
                                                    )
                                                }, null, 8, ["model-value", "label", "hint", "error-messages", "onFocus", "onBlur", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "name", "label", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.positions.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "primary",
                            class: "mb-4 mt-4",
                            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.addPosition(true)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { left: "" }, {
                                default: _withCtx(() => _cache[54] || (_cache[54] = [
                                  _createTextVNode("mdi-plus")
                                ])),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('lieferanten.rechnungformular.positionHinzufuegen')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_card, { class: "mt-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "mb-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.formData.roundingAmount,
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.formData.roundingAmount) = $event)),
                            name: "summaryRoundingAmount",
                            rules: "required"
                          }, {
                            default: _withCtx(({ errors, handleBlur }) => [
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.formData.roundingAmount,
                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formData.roundingAmount) = $event)),
                                items: _ctx.roundingOptions,
                                label: _ctx.$t('lieferanten.rechnungformular.rundungsbetrag') + ' *',
                                variant: "outlined",
                                density: "comfortable",
                                "error-messages": errors,
                                onBlur: handleBlur
                              }, null, 8, ["modelValue", "items", "label", "error-messages", "onBlur"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider, { class: "mb-4" }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, {
                            type: "info",
                            density: "compact",
                            variant: "tonal",
                            class: "text-caption mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('lieferanten.rechnungsformular.daten.uebereinstimmung')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card, {
                            variant: "outlined",
                            density: "compact",
                            class: "pa-3"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, [
                                  _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.tvskundennummer')) + ":", 1),
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formData.tvsCustomerNumber), 1)
                                ]),
                                _createElementVNode("span", _hoisted_12, [
                                  _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.firmenname')) + ":", 1),
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formData.companyName), 1)
                                ]),
                                _createElementVNode("span", _hoisted_15, [
                                  _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.ort')) + ":", 1),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formData.zipCode) + " " + _toDisplayString(_ctx.formData.cityName), 1)
                                ])
                              ]),
                              (_ctx.positions.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_divider, {
                                    key: 0,
                                    class: "my-4"
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.positions.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_simple_table, {
                                    key: 1,
                                    density: "compact",
                                    class: "vat-summary-table"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _cache[55] || (_cache[55] = _createElementVNode("th", { class: "text-left text-caption font-weight-bold pa-1" }, null, -1)),
                                          _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.totalExklMwst')), 1),
                                          _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.mwstSatz')), 1),
                                          _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.totalMwst')), 1),
                                          _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.totalInklMwst')), 1)
                                        ])
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vatGroups, (group) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: group.rate
                                          }, [
                                            _cache[56] || (_cache[56] = _createElementVNode("td", { class: "text-left text-caption pa-1" }, null, -1)),
                                            _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.formatSwissCurrency(group.net)), 1),
                                            _createElementVNode("td", _hoisted_23, _toDisplayString(group.rate) + "%", 1),
                                            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.formatSwissCurrency(group.vat)), 1),
                                            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.formatSwissCurrency(group.total)), 1)
                                          ]))
                                        }), 128)),
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.total')), 1),
                                          _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatSwissCurrency(_ctx.vatTotals.net)), 1),
                                          _cache[57] || (_cache[57] = _createElementVNode("td", { class: "text-right text-caption pa-1" }, null, -1)),
                                          _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.formatSwissCurrency(_ctx.vatTotals.vat)), 1),
                                          _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatSwissCurrency(_ctx.vatTotals.total)), 1)
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.rundungsdifferenz')), 1),
                                          _cache[58] || (_cache[58] = _createElementVNode("td", { class: "text-right text-caption pa-1" }, null, -1)),
                                          _cache[59] || (_cache[59] = _createElementVNode("td", { class: "text-right text-caption pa-1" }, null, -1)),
                                          _cache[60] || (_cache[60] = _createElementVNode("td", { class: "text-right text-caption pa-1" }, null, -1)),
                                          _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.formatSwissCurrency(_ctx.roundingDifference)), 1)
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.$t('lieferanten.rechnungformular.endbetrag')), 1),
                                          _cache[61] || (_cache[61] = _createElementVNode("td", { class: "text-right text-caption pa-1" }, null, -1)),
                                          _cache[62] || (_cache[62] = _createElementVNode("td", { class: "text-right text-caption pa-1" }, null, -1)),
                                          _cache[63] || (_cache[63] = _createElementVNode("td", { class: "text-right text-caption pa-1" }, null, -1)),
                                          _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatSwissCurrency(_ctx.totalInclVat)), 1)
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: "d-flex align-center justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ConfirmDialog, {
                            title: _ctx.$t('lieferanten.rechnungformular.bestaetigung'),
                            text: _ctx.$t('lieferanten.rechnungformular.bestaetigungText'),
                            onConfirm: _ctx.submitForm
                          }, {
                            activatorElement: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps({ id: "submit-btn" }, props, {
                                color: "primary",
                                size: "large",
                                disabled: !meta.valid || _ctx.positions.length === 0 || _ctx.missingDataAlert || !_ctx.pdfFile,
                                loading: _ctx.isSubmitting,
                                onClick: ($event: any) => (_ctx.handleSubmit(validate, $event))
                              }), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('lieferanten.rechnungsformular.einreichen')), 1)
                                ]),
                                _: 2
                              }, 1040, ["disabled", "loading", "onClick"])
                            ]),
                            _: 2
                          }, 1032, ["title", "text", "onConfirm"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_CustomerPickerDialog, {
        visible: _ctx.showCustomerPicker,
        "onUpdate:visible": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.showCustomerPicker) = $event)),
        onSelect: _ctx.onCustomerSelected
      }, null, 8, ["visible", "onSelect"])
    ]),
    _: 1
  }))
}